// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.shop-name[data-v-9bcc0be2] {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    width: 210px;\n}\n.menu-btn[data-v-9bcc0be2] {\n    position: fixed;\n    z-index: 2;\n    top: 10px;\n    left: -10px;\n    padding-left: 15px !important;\n    padding-right: 5px !important;\n    height: 38px !important;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
